import {PropsWithChildren} from "react";
import {Typography} from "@mui/material";

export interface Props extends PropsWithChildren {
    label: string;
    disabled?: boolean;
}

// In design, the labeled input color is #737990
// the color for disabled can be this #9fa3b0
export const LabeledInput: React.FC<Props> = ({children, label, disabled = false}) => (
    <div>
        <Typography fontSize={12} textTransform="uppercase" color={disabled ? "#9fa3b0" : "#737990"}>
            {label}
        </Typography>
        {children}
    </div>
);
